import angular from 'angular';
const constantsModule = angular.module('tinaba.constants.environment', [])
  .constant('envName', ENV.envName)
  .constant('endPoints',
    {
      baseUrl: MODE === "admin" ? ENV.adminBaseUrl : ENV.baseUrl,
      webApiUrl: ENV.webApiUrl,
      webApiUrlS: ENV.webApiUrlS,
      userUrl: ENV.userUrl,
      deviceUrl: ENV.deviceUrl,
      ecommerceUrl: ENV.ecommerceUrl,
      businessUrl: ENV.businessUrl,
      superAdminUrl: ENV.superAdminUrl,
      authenticatorUrl: ENV.authenticatorUrl,
      crmLightUrl: ENV.crmLightUrl,
      esbVersion: '1.5'
    }
  )
  .constant('uiConfig', {
    loaderTimeout: 50000, // ms
    callTimeout: 35000, // ms
    sessionTimeout: 5, // minutes
    homeAutoBackTimeout: 10, // seconds
    emailSender: ENV.emailSender
  })
  .constant('stentleConfig', {
    xDomain: ENV.stentleXDomain
  })
  .constant('pathSuperAdmin', MODE === "admin" ? '/superAdmin' : '/')
  .constant('API_KEY_GOOGLE', ENV.apiKeyGoogle)
  .constant('GOOGLE_CLIENT_ID', ENV.googleClientId)
  .constant('APP_MODE', MODE || "merchant");

export default constantsModule;



/** WEBPACK FOOTER **
 ** ./client/app/constants/env.js
 **/